import { useState } from 'react'
import loginSchema, { LoginSchema } from '../../../database/validations/Auth'
import { FetchStatus } from '../../../types/fetch-status.types'
import constants from '../../../constants'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import AuthService from '../../../services/auth'

const formEmptyValue: LoginSchema = {
  email: '',
  password: '',
}

export default function useAuthLoginPageViewModel() {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [loginStatus, setLoginStatus] = useState<FetchStatus>(constants.fetchStatus.default)

  const formHook = useForm<LoginSchema>({
    defaultValues: formEmptyValue,
    mode: 'onChange',
    resolver: zodResolver(loginSchema),
  })

  async function onSubmit(data: LoginSchema) {
    setLoginStatus({ ...constants.fetchStatus.default, isLoading: true })
    await AuthService.firebaseLoginEmail(data)
      .then(() => setLoginStatus({ ...constants.fetchStatus.default, isSuccess: true }))
      .catch(e => {
        console.log(e)
        setLoginStatus({ ...constants.fetchStatus.default, isError: true })
      })
  }

  const toggleShowPassword = () => setShowPassword(oldVal => !oldVal)

  return { loginStatus, formHook, onSubmit, showPassword, toggleShowPassword }
}
